module.exports = __webpack_public_path__ + "static/img/142_phase_function_Paper_PointsHejduk_Prediction.9577e71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/142_phase_function_Paper_PointsHejduk_Prediction.png
// module id = CjQj
// module chunks = 0